<div
  class="fc-outlined-multi-select"
  [class.invalid]="control.touched && control.invalid"
  [class.disabled]="control.disabled"
>
  <div
    class="fc-outlined-multi-select__infix"
    [class.float-label]="control.value.length"
    (click)="control.enabled && (showOptions = !showOptions)"
    [matTooltip]="control.value | map: displayWith"
    matTooltipPosition="above"
  >
    <label *ngIf="label" class="fc-outlined-multi-select__infix-label">
      {{ label }}
      <span *ngIf="required && !control.value.length">*</span>
    </label>
    <input
      type="text"
      [value]="control.value | map: displayWith"
      class="fc-outlined-multi-select__infix-input"
      disabled
    />
    <small class="fc-outlined-multi-select__infix-error" *ngIf="control.touched && control.invalid">
      <ng-content></ng-content>
    </small>
  </div>

  <div class="fc-outlined-multi-select__suffix" (click)="control.enabled && (showOptions = !showOptions)">
    <mat-icon
      class="fc-outlined-multi-select__suffix-drop-down"
      [ngClass]="{ 'fc-outlined-multi-select__suffix-drop-down--selected': showOptions }"
    >
      arrow_drop_down
    </mat-icon>
  </div>

  <ul *ngIf="showOptions" class="fc-outlined-multi-select__options" @fade>
    <div
      *ngIf="showAllOption && options.length > 1"
      class="fc-outlined-multi-select__options_option"
      [ngClass]="{ 'fc-outlined-multi-select__options_option--selected': isSelected(allOption) }"
      (click)="selectAll(allOptionCheckbox)"
    >
      <mat-checkbox #allOptionCheckbox [checked]="isSelected(allOption)" matRipple>
        {{ 'FC_OUTLINED_MULTI_SELECT.ALL_OPTION' | translate }}
      </mat-checkbox>
    </div>

    <div
      *ngFor="let option of options"
      class="fc-outlined-multi-select__options_option"
      [ngClass]="{ 'fc-outlined-multi-select__options_option--selected': isSelected(option) }"
      (click)="selectOption(option, optionCheckbox)"
    >
      <mat-checkbox #optionCheckbox [checked]="isSelected(option)" matRipple>
        {{ option.text }}
      </mat-checkbox>
    </div>
  </ul>
</div>
